import { render, staticRenderFns } from "./MiniAssets.vue?vue&type=template&id=8d89e6a2&scoped=true"
import script from "./MiniAssets.vue?vue&type=script&lang=js"
export * from "./MiniAssets.vue?vue&type=script&lang=js"
import style0 from "./MiniAssets.vue?vue&type=style&index=0&id=8d89e6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d89e6a2",
  null
  
)

export default component.exports